/**
 * Warehouse Details
 */

// React
import React, {useEffect, useContext, useState} from 'react';
import {useForm} from 'react-hook-form';

// Context
import AuthContext from '../../authContext';

// Redux
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Store} from '../../redux/reducers';
import {getSkuInventoryWithIdAction, getSkusInventoryFinalizedSumActions,
  getSkusInventoryNotFinalizedSumActions,} from '../warehouses/actions';

// Selector
import {createStructuredSelector} from 'reselect';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectSkusInventory,
  makeSelectSkusInventoryCount,
  makeSelectAvailableCount,
  makeSelectOnWayCount,
  makeSelectReturnedCount,
} from '../warehouses/selectors';

//UI
import clsx from 'clsx';
import {makeStyles, createStyles, Theme} from '@material-ui/core/styles';
import {
  Typography,
  Paper,
  Grid,
  Button,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
  IconButton,
  InputBase,
  ClickAwayListener,
} from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import RenderFilter from '../../utils/listDaynamicFilter';

// Icon
import Icon from '@mdi/react';
import {
  mdiKeyOutline,
  mdiArrowRight,
  mdiCounter,
  mdiHomeCityOutline,
  mdiWarehouse,
  mdiMagnify, mdiCalendarCheckOutline, mdiTruckDeliveryOutline, mdiClose,
} from '@mdi/js';

// Component
import ListSkuInventoryDetails from './components/listSkuInventoryDetails';

// Helper
import {removeEmptyValueObject} from '../../utils/helpers';

// Type
import {
  PropsSkusInventoryDetails,
  SelectorPropsSkusInventoryDetails,
} from './interfaces';
import {PayloadInventoryById} from '../warehouses/interfaces';
import type {Filter} from '../../utils/listDaynamicFilter';
import {makeSelectCountActiveList, makeSelectCountDeactiveList, makeSelectCountList} from '../centers/selectors';
import {useParams} from 'react-router-dom';

import handleError from "../../utils/handleError";
import handleNotfication from "../../utils/handleNotification";
import skusRepository from "client-sdk/src/Repository/skus-repository";

type Inputs = {
  'name.contains': string;
};

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
      "& #showFilter .MuiInput-underline::before, & #showFilter .MuiInput-underline::after": {
        borderBottom: '2px solid #DFA01F !important',
      }
    },
    paper: {
      marginTop: '36px',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
      '@media (max-width: 768px)': {
        padding: theme.spacing(0),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        backgroundColor: theme.palette.background.default,
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
    },
    showCount: {
      "& .MuiSelect-icon": {
        color: "#DFA01F",
      },
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      padding: '10px 0',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },

    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 8,
      position: 'relative',
      marginRight: '10px',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    returnButton: {
      margin: '40px 0 36px',
      padding: 0,
    },
    boxes: {
      marginBottom: '20px',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: '0',
      marginTop: '12px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    box: {
      display: 'flex',
      backgroundColor: '#fff',
      padding: theme.spacing(3, 4),
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    boxIcon: {
      // display: 'flex',
      // alignItems: 'center',
      marginRight: '30px',
    },
    allCenter: {
      position: 'relative',
      marginRight: '40px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#696969',
      },
    },
    activeCenter: {
      position: 'relative',
      marginRight: '40px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#039590',
      },
    },
    diactiveCenter: {
      position: 'relative',
      marginRight: '40px',

      '&:before': {
        content: '""',
        position: 'absolute',
        width: '60px',
        height: '60px',
        top: '47%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        borderRadius: '50%',
        opacity: '0.3',
        backgroundColor: '#fd8686',
      },
    },

    title: {
      display: 'flex',
      alignItems: 'center',
      color: '#8A8A8A',
      fontSize: '16px',
      fontWeight: 500,
      marginRight: '8px',
    },
    text: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '21px',
      fontWeight: 500,
      padding: '0 30px'
    },
  })
);

export function SkuInventoryDetails(props: PropsSkusInventoryDetails) {
  const authContext = useContext(AuthContext);

  const classes = useStyles();
  const {register, handleSubmit} = useForm<Inputs>();

  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [filters, setFilters] = useState([] as Filter[]);
  const urlParams = useParams();
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 10,
  } as any);
  const [openFilterBox, setOpenFilterBox] = useState(false as boolean);




  const [skuInventory, setSkuInventory] = useState([]);
  const [skuInventoryCount, setSkuInventoryCount] = useState(0);
  const [availableCount, setAvailableCount] = useState(0);
  const [onWayCount, setOnWayCount] = useState(0);
  const [returnedCount, setReturnedCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    getSkusInventory();
    getSkusInventoryFinalizedSum();
    getSkusInventoryNotFinalizedSum();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps
  const getSkusInventoryFinalizedSumReq=async(actions:any)=>{
    const payload = {...actions};
      try {
        setLoading(true);
        const response = await skusRepository.getSkusInventoryFinalizedSum({payload});
        setAvailableCount(response.data.totalElements);
      } catch (error) {
        setError(error.message);
          handleError(error.response);
      }finally{
        setLoading(false);
      }
  }
  const getSkusInventory = () => {
    const {skuId} = props.match.params;
    const {page, size} = filtersValues;
    getSkusInventoryFinalizedSumReq({
        skuId,
        ...removeEmptyValueObject(filtersValues),
        page,
        size
    });
  }
  const getSkusInventoryNotFinalizedSumReq=async(actions:any)=>{
    const payload = {...actions};
      try {
        setLoading(true);
        const response = await skusRepository.getSkusInventoryNotFinalizedSum({payload});
        setOnWayCount(response.data.totalElements);

      } catch (error) {
        setError(error.message);
          handleError(error.response);
      }finally{
        setLoading(false);
      }
  }
  const getSkusInventoryFinalizedSum = () => {
    const {skuId} = props.match.params;
    const {page, size} = filtersValues;
    getSkusInventoryNotFinalizedSumReq({
        skuId,
        ...removeEmptyValueObject(filtersValues),
        page,
        size
    });
  }
  const getSkusInventoryWithId=async(actions:any)=>{
    const payload = {...actions};
      try {
        setLoading(true);
        const response = await skusRepository.getSkusInventoryWithId({payload});
        setSkuInventory(response.data.content);
        setSkuInventoryCount(response.data.totalElements);
      } catch (error) {
        setError(error.message);
          handleError(error.response);
      }finally{
        setLoading(false);
      }
  }

  const getSkusInventoryNotFinalizedSum = () => {
    const {skuId} = props.match.params;
    const {page, size} = filtersValues;
    getSkusInventoryWithId({skuId, 
      ...removeEmptyValueObject(filtersValues),
      page,
      size,
    });
  }

  const handleClose = () => {
    setOpenSize(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{value: unknown}>) => {
    setFiltersValues({...filtersValues, page: 0, size: event.target.value});
  };

  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({...filtersValues, page: page - 1});
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'name.contains',
        label: 'نام انبار',
        icon: mdiWarehouse,
      },
      {
        type: 'input',
        id: 'id.equals',
        label: 'شناسه انبار',
        icon: mdiKeyOutline,
      },
      {
        type: 'input',
        id: 'province.contains',
        label: 'استان',
        icon: mdiHomeCityOutline,
      },
      {
        type: 'input',
        id: 'city.contains',
        label: 'شهر',
        icon: mdiHomeCityOutline,
      },
    ]);
  };

  const handleClick = () => {
    setOpenFilterBox(prev => !prev);
  };

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
        'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  const onSubmit = (filtervalues: any) => {
    setFiltersValues({
      ...removeEmptyValueObject(filtervalues),
      page: 0,
      size: 10,
    });
    setOpenFilterBox(false);
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={5} alignItems="center">
        <Grid item xs={12} sm={6}>
          <div className={classes.headerBox}>
            <Typography variant="h6" component="h2">
              {`
       لیست موجودی  
    ${props.match.params?.name}
     
        `}
            </Typography>
            <span className={classes.contentlabelTitle}>
              {props.match.params?.skuId}
            </span>
          </div>
        </Grid>

        <Grid item xs={12} sm={6}>
          <div className={classes.searchBox}>
            <form onSubmit={handleSubmit(onSubmit)} className={classes.input}>
              <IconButton
                type="submit"
                className={classes.iconButton}
                aria-label="search"
              >
                <Icon
                  path={mdiMagnify}
                  size={1}
                  className={classes.magnifyIcon}
                />
              </IconButton>
              <InputBase
                className={classes.input}
                name="name.contains"
                placeholder="نام انبار "
                inputRef={register({required: true})}
                inputProps={{'aria-label': 'search google maps'}}
              />
            </form>
            <ClickAwayListener onClickAway={handleClickAway}>
              <div>
                <Button
                  type="button"
                  onClick={handleClick}
                  className={classes.iconButton}
                  aria-label="search"
                >
                  جستجوی پیشرفته
                </Button>
                {openFilterBox ? (
                  <div
                    className={clsx(classes.filterBox, {
                      [classes.filterOpen]: openFilterBox,
                    })}
                  >
                    <RenderFilter
                      filters={filters}
                      onFilter={(filtervalues: any) => {
                        setFiltersValues({
                          ...filtervalues,
                          page: 0,
                          size: 10,
                          // partnerId: {
                          //   equals: props.match.params.warehousesId || null,
                          // },
                        });
                        setOpenFilterBox(false);
                      }}
                    />
                  </div>
                ) : null}
              </div>
            </ClickAwayListener>
          </div>
        </Grid>
      </Grid>

      <Grid>
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
          className={classes.returnButton}
        >
          <Icon path={mdiArrowRight} size={1} />
          {`بازگشت`}
        </Button>
      </Grid>

      {authContext.user.role !== "SELLER_ADMIN" && (
        <Grid className={classes.boxes} container spacing={5}>
          <Grid item xs={4}>
            <div className={classes.box}>
              <div className={classes.allCenter}>
                <Icon
                  size={2}
                  path={mdiCalendarCheckOutline}
                  style={{color: '#5c5c5c', padding: '5px'}}
                />
              </div>
              <div className={classes.title}>در دسترس:</div>
              <div className={classes.text}>{availableCount}</div>
            </div>
          </Grid>
          <Grid item xs={4}>
            <div className={classes.box}>
              <div className={classes.activeCenter}>
                <Icon size={2} path={mdiTruckDeliveryOutline} style={{color: '#039590', padding: '5px'}} />
              </div>
              <div className={classes.title}>در راه انبار:</div>
              <div className={classes.text}>{onWayCount}</div>
            </div>
          </Grid>

          <Grid item xs={4}>
            <div className={classes.box}>
              <div className={classes.diactiveCenter}>
                <Icon size={2} path={mdiClose} style={{color: '#F30000'}} />
              </div>
              <div className={classes.title}>بازگردانده شده:</div>
              <div className={classes.text}>{returnedCount}</div>
            </div>
          </Grid>

        </Grid>
      )}


      <Grid id="showFilter" container item spacing={6}>
        <Grid item xs={12}>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            skuInventory && (
              <ListSkuInventoryDetails
                productName={urlParams.name}
                variantId={urlParams.skuId}
                data={skuInventory}
                skuId={props.match.params?.skuId}
              />
            )
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {skuInventory && (
            <FormControl
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div style={{marginLeft: '10px', color: '#8a8a8a'}}>
                {' '}
                تعداد نمایش در هر صفحه:
              </div>
              <Select
                open={openSize}
                onClose={handleClose}
                className={classes.showCount}
                onOpen={() => setOpenSize(true)}
                value={filtersValues.size}
                onChange={handleChangeSizePage}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          {skuInventory && (
            <Pagination
              count={Math.ceil(skuInventoryCount / filtersValues.size)}
              color="secondary"
              page={filtersValues.page + 1}
              onChange={handleChangePage}
            />
          )}
        </Grid>
      </Grid>
    </div>
  );
}

// const mapStateToProps = createStructuredSelector<
//   Store,
//   SelectorPropsSkusInventoryDetails
// >({
//   skuInventory: makeSelectSkusInventory(),
//   skuInventoryCount: makeSelectSkusInventoryCount(),
//   availableCount: makeSelectAvailableCount(),
//   onWayCount: makeSelectOnWayCount(),
//   returnedCount: makeSelectReturnedCount(),
//   loading: makeSelectLoading(),
//   error: makeSelectError(),
// });

// function mapDispatchToProps(dispatch: Function) {
//   return {
//     getSkusInventoryWithIdDispatch: (id: number, pagination: object) =>
//       dispatch(getSkuInventoryWithIdAction({id, pagination})),
//     getSkusInventoryFinalizedSumDispatch: (id: number, pagination: object) =>
//       dispatch(getSkusInventoryFinalizedSumActions({id, pagination})),
//     getSkusInventoryNotFinalizedSumDispatch: (id: number, pagination: object) =>
//       dispatch(getSkusInventoryNotFinalizedSumActions({id, pagination})),
//   };
// }

// const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default SkuInventoryDetails;
